var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper mySwiper"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.nav),function(item){return _c('li',{key:item.label,class:['swiper-slide',item.path === _vm.routePath ? 'on' : '']},[_c('a',{attrs:{"href":item.path}},[_vm._v(_vm._s(item.label))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }